import {
  type DatagridConfigurableProps,
  DatagridConfigurable,
  TextField,
  NumberField,
  FunctionField,
} from "react-admin";

import { type StatisticsRowRecord } from "./types";

const PERCENT_DECIMALS = 2;

const CURRENCY_OPTIONS = {
  style: "currency",
  currency: "USD",
};

export const StatisticsDatagrid = (props: DatagridConfigurableProps) => (
  <DatagridConfigurable bulkActionButtons={false} {...props}>
    <TextField source="group" />
    <TextField source="installs" />
    <TextField source="subs" />
    <TextField source="trials" />
    <TextField source="converted" />
    <FunctionField
      label="TCR"
      source="TCR"
      render={(record: StatisticsRowRecord) =>
        `${record.TCR.toFixed(PERCENT_DECIMALS)}%`
      }
    />
    <FunctionField
      label="SCR"
      source="SCR"
      render={(record: StatisticsRowRecord) =>
        `${record.SCR.toFixed(PERCENT_DECIMALS)}%`
      }
    />
    <TextField source="refund" />
    <TextField source="abuse" />
    <TextField source="rebills" />
    <NumberField source="costs" options={CURRENCY_OPTIONS} />
    <NumberField label="CPT" source="CPT" options={CURRENCY_OPTIONS} />
    <NumberField source="revenue" options={CURRENCY_OPTIONS} />
    <NumberField source="refundSum" options={CURRENCY_OPTIONS} />
    <NumberField source="profit" options={CURRENCY_OPTIONS} />
    <NumberField label="PPS" source="PPS" options={CURRENCY_OPTIONS} />
    <NumberField label="PPT" source="PPT" options={CURRENCY_OPTIONS} />
    <FunctionField
      label="ROI"
      source="ROI"
      render={(record: StatisticsRowRecord) =>
        `${record.ROI.toFixed(PERCENT_DECIMALS)}%`
      }
    />
  </DatagridConfigurable>
);
